import { type GetHookResponse } from '../hooks'
import { teamKey } from '../keys'
import { useTantalimQuery } from '../query'
import { useTeamCache } from './cache'
import { HOUR, isNotEmpty, Logger, type TeamGetInput, type TeamGetSuccess, type TeamId } from '@terros/common'

const logger = new Logger('useTeam')

export function useTeam(teamId?: TeamId, enabled = true): GetHookResponse<TeamGetSuccess> {
  logger.verbose('calling useTeam', teamId)
  const cache = useTeamCache()
  return useTantalimQuery<TeamGetInput, TeamGetSuccess, TeamGetSuccess>({
    url: '/team/get',
    queryKey: teamKey(teamId),
    input: {
      teamId: teamId ?? 'Team:EMPTY_TEAM',
    },
    convertResponse: (data) => {
      cache.setTinyTeam(data.team)
      if (isNotEmpty(data.childTeams)) cache.setTinyTeams(data.childTeams)
      return data
    },
    options: {
      gcTime: HOUR,
      staleTime: HOUR,
      enabled: Boolean(teamId) && enabled,
    },
  })
}
